import { ColumnsType } from "antd/es/table";
import { SpeedAnalysisDetail } from "shared/api/productionAnalysis/models";

export const useSpeedAnalysisColumns = (): ColumnsType<SpeedAnalysisDetail> => {
  return [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => status ?? "N/A",
    },
    {
      title: "Average Y",
      dataIndex: "avg_y",
      key: "avg_y",
      render: (avg_y: number) => avg_y?.toFixed(2) ?? "N/A",
    },
    {
      title: "Min Y",
      dataIndex: "min_y",
      key: "min_y",
      render: (min_y: number) => min_y?.toFixed(2) ?? "N/A",
    },
    {
      title: "Max Y",
      dataIndex: "max_y",
      key: "max_y",
      render: (max_y: number) => max_y?.toFixed(2) ?? "N/A",
    },
    {
      title: "Median Y",
      dataIndex: "median_y",
      key: "median_y",
      render: (median_y: number) => median_y?.toFixed(2) ?? "N/A",
    },
    {
      title: "Std Y",
      dataIndex: "std_y",
      key: "std_y",
      render: (std_y: number) => std_y?.toFixed(2) ?? "N/A",
    },
    {
      title: "COV Y",
      dataIndex: "cov_y",
      key: "cov_y",
      render: (cov_y: number) => cov_y?.toFixed(2) ?? "N/A",
    },
    {
      title: "Delta Seconds",
      dataIndex: "delta_seconds",
      key: "delta_seconds",
      render: (delta_seconds: number) => delta_seconds ?? "N/A",
    },
    {
      title: "Delta Minutes",
      dataIndex: "delta_minutes",
      key: "delta_minutes",
      render: (delta_minutes: number) => delta_minutes ?? "N/A",
    },
  ];
};
